import styles from './Skeleton.module.css';

/**
 * Modern Skeleton Loading Component
 * variants: 'box' | 'text' | 'circle' | 'card' | 'list'
 */
const Skeleton = ({ variant = 'box', width, height, className = '', count = 1 }) => {
  const renderItem = (i) => {
    if (variant === 'card') {
      return (
        <div key={i} className={`${styles.layoutCard} ${className}`}>
          <div className={styles.skeleton} style={{ width: '40%', height: '24px' }}></div>
          <div className={styles.skeleton} style={{ width: '100%', height: '14px' }}></div>
          <div className={styles.skeleton} style={{ width: '70%', height: '14px' }}></div>
          <div className={styles.skeleton} style={{ width: '100px', height: '36px', marginTop: '8px', borderRadius: '12px' }}></div>
        </div>
      );
    }
    
    if (variant === 'list') {
      return (
        <div key={i} className={styles.layoutList}>
          {Array.from({ length: Math.max(1, count) }).map((_, j) => (
             <div key={j} className={`${styles.layoutCard} ${className}`} style={{ flexDirection: 'row', alignItems: 'center' }}>
               <div className={`${styles.skeleton} ${styles.variantCircle}`} style={{ width: '48px', height: '48px', flexShrink: 0 }}></div>
               <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                 <div className={styles.skeleton} style={{ width: '30%', height: '16px' }}></div>
                 <div className={styles.skeleton} style={{ width: '60%', height: '12px' }}></div>
               </div>
             </div>
          ))}
        </div>
      );
    }

    let variantClass = styles.variantBox;
    if (variant === 'text') variantClass = styles.variantText;
    if (variant === 'circle') variantClass = styles.variantCircle;

    const customStyle = {};
    if (width) customStyle.width = typeof width === 'number' ? `${width}px` : width;
    if (height) customStyle.height = typeof height === 'number' ? `${height}px` : height;

    return (
      <div
        key={i}
        className={`${styles.skeleton} ${variantClass} ${className}`.trim()}
        style={customStyle}
      />
    );
  };

  // Standard variants don't loop internally unless we want to, but 'list' handles its own count differently to avoid nested containers if we don't want them.
  // Actually, let's just loop them all if count > 1.
  if (variant === 'list') {
     return renderItem(0); 
  }

  if (count > 1) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
        {Array.from({ length: count }).map((_, i) => renderItem(i))}
      </div>
    );
  }

  return renderItem(0);
};

export default Skeleton;
